export default __webpack_public_path__ + "static/media/b2.f3cee532.webp";